module.exports = __webpack_public_path__ + "img/20200108155659119.fa16365a.jpg";